import { selectedTheme, selectedThemeMode } from '@/redux/theme/selectors'
import { setInitialTheme, setTheme } from '@/redux/theme/slice'
import { EThemes } from '@/redux/theme/types'
import { FC, PropsWithChildren, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch()
  const storageTheme = useSelector(selectedTheme)
  const mode = useSelector(selectedThemeMode)

  useEffect(() => {
    let theme: EThemes = EThemes.light
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      theme = EThemes.dark
    }

    if (storageTheme) {
      if (storageTheme === EThemes.light) {
        theme = EThemes.light
      }
      if (storageTheme === EThemes.dark) {
        theme = EThemes.dark
      }
    }

    if (storageTheme !== theme) {
      dispatch(setTheme(theme))
      dispatch(setInitialTheme(theme))
    }
  }, [])

  useEffect(() => {
    if (storageTheme) {
      document.documentElement.setAttribute('data-theme', storageTheme)
    }
  }, [storageTheme])

  useEffect(() => {
    if (mode) {
      document.documentElement.setAttribute('data-size-mode', mode)
    }
  }, [mode])
  return <>{children}</>
}

export default ThemeProvider
